/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Colleagues_TitleInputs */



/**
* | output |
* | --- |
* | "Select your upcoming one-to-ones" |
*
* @param {Onboarding_Colleagues_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const onboarding_colleagues_title = /** @type {((inputs?: Onboarding_Colleagues_TitleInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Colleagues_TitleInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Selecteer je komende one-to-ones")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sélectionnez vos prochains one-to-ones")
	return /** @type {LocalizedString} */ ("Select your upcoming one-to-ones")
});